/**
 * @description: 订台业绩明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="dm-report">
        <div class="dm-list" v-show="!showDmDet">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="dmTime">
                        <input type="text" class="form-control laydate-icon" v-model="dmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="dmEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dmShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">消费包厢:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dm_perf_box" data-placeholder="请选择消费包厢" disabled>
                    </select>
                </div>
                <label class="list-label-3">账单号:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入账单号" v-model="dm_bill_no">
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="perf_tit_sel">
                        <option value="">全部</option>
                        <option value="personnel">艺人</option>
                        <option value="user">员工</option>
                        <option value="consumer">散客</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="perf_con_val" ref="perf_con_val" :placeholder="perf_con_phd">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="dm_group_type" ref="dm_group_type" @click="enterGroup" readonly disabled>
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dm_charger" data-placeholder="请选择主管" disabled></select>
                </div>
                <!-- <label class="list-label-x">是否剔除免单支付金额:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dm_is_free">
                        <option value="-1">否</option>
                        <option value="1">是</option>
                    </select>
                </div> -->
                <label class="list-label-7">需剔除金额类型:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请选择需要剔除金额的支付类型" @click="openExcludePayPlatform" v-model="excludePayPlatform_str"/>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-x">是否显示满低消的账单:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="dm_is_dx">
                        <option value="0">全部</option>
                        <option value="-1">显示不满低消账单</option>
                        <option value="1">显示满低消账单</option>
                    </select>
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢类型" ref="dmBoxType"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getDmList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getDmExportSet">导出</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="dm_list_table">
                <el-table-column prop="group_name" label="组别"></el-table-column>
                <el-table-column prop="book_admin_name" label="订台人"></el-table-column>
                <el-table-column prop="book_admin_number" label="订台人工号" min-width="90"></el-table-column>
                <el-table-column prop="director_name" label="主管"></el-table-column>
                <el-table-column prop="room_name" label="消费包厢"></el-table-column>
                <el-table-column prop="room_type_name" label="包厢类型"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" min-width="120"></el-table-column>
                <el-table-column prop="bill_amount" label="账单实收金额"></el-table-column>
                <el-table-column prop="amount" label="业绩"></el-table-column>
                <el-table-column prop="vip_account" label="会员通用账户支付"></el-table-column>
                <el-table-column prop="vip_room_account" label="会员房费账户支付"></el-table-column>
                <el-table-column prop="vip_present_account" label="会员赠送账户支付"></el-table-column>
                <el-table-column prop="amount_exclude_vip" label="扣除会员支付金额"></el-table-column>
                <el-table-column prop="start_time" label="开房时间" min-width="110"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
						<span class="text-blue" @click="dmDetail(scope.row.bill_no)">详情</span>
					</template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-2">业绩:</label>
                    <div class="list-total">{{dm_total_amount}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dm_list_page"
                    :total="dm_list_total"
                    @current-change="getDmList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="dmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='dmExport_allcheck' @click='dmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="book_admin_name">
                            <label>订台人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="book_admin_number">
                            <label>订台人工号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="room_name">
                            <label>消费包厢</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="room_type_name">
                            <label>包厢类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="bill_no">
                            <label>账单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="bill_amount">
                            <label>账单实收金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="amount">
                            <label>业绩</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="vip_account">
                            <label>会员通用账户支付</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="vip_room_account">
                            <label>会员房费账户支付</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="vip_present_account">
                            <label>会员赠送账户支付</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="amount_exclude_vip">
                            <label>扣除会员支付金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='dmExport_checkModel' value="start_time">
                            <label>开房时间</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='dmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='dmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="dm-det" v-show="showDmDet">
            <billDetail ref="dm_bill_det" @backBdwPre="showDmDet = false"></billDetail>
        </div>
        <!-- 组别列表 -->
        <div class="group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="group_name">
                <img src="../../../assets/images/group_search.png" @click="getGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='group_allcheck' @click='groupCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="groupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="groupSub()">确定</button>
            </div>
        </div>
        <!-- 支付金额类型弹窗 -->
        <div class="pay-platform-pop" ref="pay_platform_pop">
            <el-checkbox :indeterminate="checkAllFlag" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="exclude_pay_platform" @change="handleCheckedPayPlatformChange">
                <el-checkbox v-for="item in excludePayPlatform" :label="item.id" :value="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                showDmDet: false,
                dmStartTime: "",
                dmEndTime: "",
                dm_group_type: "",
                perf_field: "",
                perf_con_phd: "请输入订台人姓名",
                perf_con_val: "",
                dm_bill_no: '',
                dm_charger_type: '',
                group_allcheck: false,
                c_group_allcheck: false,
                group_checkboxModel: [],
                c_group_checkboxModel: [],
                group_checkboxData: [],
                group_name: '',
                dm_list_table: [],
				dm_list_page: 1,
                dm_list_total: 0,
                dm_total_amount: '',
                dmExport_allcheck: false,
                c_dmExport_allcheck: false,
                dmExport_checkModel: [],
                dmExport_checkData: ['group_name', 'book_admin_name', 'book_admin_number', 'director_name', 'room_name', 'room_type_name', 'bill_no', 'bill_amount', 'amount', 'vip_account', 'vip_room_account', 'vip_present_account', 'amount_exclude_vip', 'start_time'],
                dmExport_type: 1,
                excludePayPlatform: [], // 需要剔除的全部类型
                exclude_pay_platform: [], // 选择的需要剔除的金额类型
                excludePayPlatform_str: '', 
                checkAllFlag: false,
                checkAll: false,
            }
        },
        components: {
            "billDetail": billDetail
        },
        watch: {
            '$route': {
				handler: function(val, oldVal) {
					if(val.params.start_date) {
						this.dmStartTime = val.params.start_date
                        this.dmEndTime = val.params.end_date
                        if (val.params.book_admin_type == '3') { // 散客
                            this.perf_field = 'consumer'
                            $(this.$refs.perf_tit_sel).val(this.perf_field).trigger('change');
                            this.perf_con_phd = ''
                            this.perf_con_val = ''
                        }else {
                            this.perf_field = ''
                            $(this.$refs.perf_tit_sel).val(this.perf_field).trigger('change');
                            this.perf_con_phd = '请输入订台人姓名'
                            this.perf_con_val = val.params.search_word
                        }
                        $(this.$refs.dmShop).val(val.params.shop_id).trigger('change')
                        this.getDmList(1)
					}
				},
				deep: true
			},
            group_checkboxModel: {
                handler: function (val, oldVal) {
                    if(this.group_checkboxModel.length >= this.group_checkboxData.length) {
                        this.group_allcheck = true;
                        this.c_group_allcheck = true;
                    } else {
                        this.group_allcheck = false;
                        this.c_group_allcheck = false;
                    }
                },
                deep: true
            },
            perf_field: {
                handler: function(val, oldVal) {
                    if(val == '' || val == 'consumer') {
                        $(this.$refs.dm_group_type).prop('disabled', true);
                    } else {
                        $(this.$refs.dm_group_type).prop('disabled', false);
                    }
                },
                deep: true
            },
            dmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.dmExport_checkModel.length >= this.dmExport_checkData.length) {
                        this.dmExport_allcheck = true;
                        this.c_dmExport_allcheck = true;
                    } else {
                        this.dmExport_allcheck = false;
                        this.c_dmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.dmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.dmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            // 下拉选项
            $(_this.$refs.perf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                $(_this.$refs.dm_charger).val('').trigger('change');
                $(_this.$refs.dm_charger).prop("disabled", true);
                _this.perf_field = $(this).val();
                _this.perf_con_val = '';
                $(_this.$refs.perf_con_val).prop("disabled", false);
                if(_this.perf_field == '') {
                    _this.perf_con_phd = '请输入订台人姓名';
                } else if(_this.perf_field == 'personnel') {
                    _this.perf_con_phd = '请输入艺人姓名';
                    $(_this.$refs.dm_charger).prop("disabled", false);
                } else if(_this.perf_field == 'user') {
                    _this.perf_con_phd = '请输入员工姓名';
                } else if(_this.perf_field == 'consumer') {
                    _this.perf_con_phd = '';
                    $(_this.$refs.perf_con_val).prop("disabled", true);
                }
                _this.group_checkboxModel = [];
                _this.dm_group_type = '';
            });
            $(_this.$refs.perf_tit_sel).val('').trigger('change');
            _this.perf_field == ''
            _this.perf_con_phd = '请输入订台人姓名';
            _this.perf_con_val = '';
            // $(_this.$refs.dm_is_free).select2({
            //     language: "zh-CN",
            //     minimumResultsForSearch: -1,
            //     width: '100%'
            // });
            $(_this.$refs.dm_is_dx).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
            _this.shopDatas = [];

            // 第一次打开
			if(_this.$route.params.start_date) {
                _this.dmStartTime = _this.$route.params.start_date
                _this.dmEndTime = _this.$route.params.end_date
                if (_this.$route.params.book_admin_type == '3') { // 散客
                    _this.perf_field = 'consumer'
                    _this.perf_con_val = ''
                    $(_this.$refs.perf_tit_sel).val(_this.perf_field).trigger('change');
                }else {
				    _this.perf_con_val = _this.$route.params.search_word
                }
                _this.innitInput(_this.$route.params.shop_id)
			} else {
                _this.innitInput();  // 门店
            }
        },
        methods: {
            setShopDefaultTime(shop_id) {
                if(!!this.$route.params.start_date) {
                    return
                }
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.dmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.dmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.dmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.dmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.dmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.dmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.dm_perf_box).html("");
                                    $(_this.$refs.dm_perf_box).prop("disabled", true);
                                    // 主管
                                    $(_this.$refs.dm_charger).val('').trigger('change');
                                    $(_this.$refs.dm_charger).prop("disabled", true);
                                    // 包厢类型
                                    $(_this.$refs.dmBoxType).val('').trigger('change');
                                    $(_this.$refs.dmBoxType).prop('disabled', true);
                                    return;
                                }
                                $(_this.$refs.dm_perf_box).prop("disabled", false);
                                _this.getRoomdata(e.params.data.id);
                                // 主管
                                $(_this.$refs.dm_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);

                                _this.group_checkboxModel = [];
                                _this.dm_group_type = '';
                                // 包厢类型
                                $(_this.$refs.dmBoxType).prop('disabled', false);
                                _this.getBoxType(e.params.data.id, 'dm');
                                // 需要剔除的支付金额
                                _this.exclude_pay_platform = []
                                _this.excludePayPlatform_str = ''
                                _this.getExcludePayPlatform(e.params.data.id)
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.dmShop).val(shop_id || data.response.result[1].id).trigger('change');
                            $(_this.$refs.dm_perf_box).prop("disabled", false);
                            _this.getRoomdata(data.response.result[1].id);
                            // 主管
                            _this.getChargeData(data.response.result[1].id);
                            // 包厢类型
                            $(_this.$refs.dmBoxType).prop('disabled', false);
                            _this.getBoxType($(_this.$refs.dmShop).val(), 'dm');
                            // 需要剔除的支付金额
                            _this.getExcludePayPlatform(data.response.result[1].id)
                            _this.setShopDefaultTime(data.response.result[1].id)

                            _this.getDmList(1)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢号
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.dm_perf_box).html("");
                            $(_this.$refs.dm_perf_box).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.dm_charger).html('');
                            $(_this.$refs.dm_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.dm_charger_type = e.params.data.type;
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },
            // 获取包厢类型
            getBoxType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getRoomType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            // 初始化
                            $(_this.$refs.dmBoxType).html('');
                            $(_this.$refs.dmBoxType).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取要剔除的金额类型
            getExcludePayPlatform: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExcludePayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.excludePayPlatform = data.response.result
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },


            // 订台业绩明细报表表格
            getDmList(page) {
				const _this = this;

                _this.loading = true;
                _this.dm_list_page = page
				Vue.axios.post('FinanceReport/getAchievementDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.dmStartTime,
                            "end_date": _this.dmEndTime,
                            "shop_id": $(_this.$refs.dmShop).val(),
                            "room_id": $.trim($(_this.$refs.dm_perf_box).val()),
                            "key_word": _this.perf_field,
                            "search_word": _this.perf_con_val,
                            "group_ids": _this.group_checkboxModel,
                            "bill_no": _this.dm_bill_no,
                            "director_id": $.trim($(_this.$refs.dm_charger).val()),
                            "director_type": _this.dm_charger_type,
                            "exclude_free_amount": $(_this.$refs.dm_is_free).val()|| -1,
                            "minimum_status": $(_this.$refs.dm_is_dx).val(),
                            "room_type": $.trim($(_this.$refs.dmBoxType).val()),
                            "exclude_pay_platform": _this.exclude_pay_platform,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.dm_list_total = Number(res.data.response.result.count);
							_this.dm_total_amount = res.data.response.result.total_amount;
						}
						_this.dm_list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 详情
            dmDetail(bill_no) {
                this.$refs.dm_bill_det.getBdwDetail(bill_no)
                this.showDmDet = true
            },
            // 获取导出设置
            getDmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/achievementDetailListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.dmExport_checkModel = data.response.result.export_fields;
                                _this.dmExport_type = data.response.result.export_type;
                            } else {
                                _this.dmExport_checkModel = _this.dmExport_checkData;
                                _this.dmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.dmExport_alert)
                }, function() {
                    _this.exportDmList();
                });
            },
            // 导出字段全选
            dmExportCheckedAll: function() {
                let _this = this;
                _this.dmExport_allcheck = _this.c_dmExport_allcheck;
                if(!_this.dmExport_allcheck) { // 实现全选
                    _this.dmExport_checkModel = [];
                    _this.dmExport_checkData.forEach(function(item) {
                        _this.dmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.dmExport_checkModel = [];
                }
            },
            // 导出订台业绩明细
            exportDmList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.dmShop).val(),
                    room_id = $.trim($(_this.$refs.dm_perf_box).val());
                let export_fields = JSON.stringify(_this.dmExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/achievementDetailListExport?" +
                    "&start_date=" + _this.dmStartTime +
                    "&end_date=" + _this.dmEndTime +
                    "&shop_id=" + shop_id +
                    "&room_id=" + room_id +
                    "&key_word=" + _this.perf_field +
                    "&search_word=" + _this.perf_con_val +
                    "&group_ids=" + _this.group_checkboxModel +
                    "&bill_no=" + _this.dm_bill_no +
                    "&director_id=" + $.trim($(_this.$refs.dm_charger).val()) +
                    "&director_type=" + _this.dm_charger_type +
                    "&exclude_free_amount=" + ($(_this.$refs.dm_is_free).val()||-1) +
                    "&minimum_status=" + $(_this.$refs.dm_is_dx).val() +
                    "&room_type=" + $.trim($(_this.$refs.dmBoxType).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.dmExport_type + 
                    "&exclude_pay_platform=" + _this.exclude_pay_platform;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 进入选择组别
            enterGroup: function() {
                this.c_group_checkboxModel = this.group_checkboxModel;
                this.group_checkboxModel = [];
                this.getGroupData();
                this.group_checkboxModel = this.c_group_checkboxModel;
                $('.dm-list').hide();
                $('.group').show();
            },
            // 获取组别列表
            getGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.dmShop).val(),
                            "key_word": _this.perf_field,
                            "group_name": _this.group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupCheckedAll: function() {
                let _this = this;
                _this.group_allcheck = _this.c_group_allcheck;
                if(!_this.group_allcheck) { // 实现全选
                    _this.group_checkboxModel = [];
                    _this.group_checkboxData.forEach(function(item) {
                        _this.group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.group_checkboxModel = [];
                }
            },
            // 返回
            groupBack: function() {
                $('.group').hide();
                $('.dm-list').show();
                this.group_checkboxModel = this.c_group_checkboxModel;
            },
            groupSub: function() {
                let _this = this;
                let arr = [];
                _this.group_checkboxData.forEach(function(item) {
                    _this.group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.dm_group_type = arr.join(',');
                $('.group').hide();
                $('.dm-list').show();
            },

            // 打开剔除弹窗
            openExcludePayPlatform: function () {
                let _this = this 
                let c_exclude_pay_platform = this.exclude_pay_platform
                let c_excludePayPlatform_str = this.excludePayPlatform_str
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['金额类型选择', true],
                    area: ['750px', ''], // 宽高
                    content: $(_this.$refs.pay_platform_pop),
                    cancel: function() {
                        _this.exclude_pay_platform = c_exclude_pay_platform
                        _this.excludePayPlatform_str = c_excludePayPlatform_str
                    }
                }, function() {
                    let arr = []
                    _this.exclude_pay_platform.forEach(item => {
                        _this.excludePayPlatform.forEach(v => {
                            if (item == v.id) {
                                arr.push(v.name)
                            }
                        })
                    })
                    _this.excludePayPlatform_str = arr.join(",")
                    layer.closeAll()
                }, function() {
                    _this.exclude_pay_platform = c_exclude_pay_platform
                    _this.excludePayPlatform_str = c_excludePayPlatform_str
                    layer.closeAll()
                });
            },

            handleCheckAllChange: function(val) {
                this.exclude_pay_platform = []
                if (val) {
                    this.excludePayPlatform.forEach(item => {
                        this.exclude_pay_platform.push(item.id)
                    })
                }
                this.checkAllFlag = false;
            },
            handleCheckedPayPlatformChange: function (val) {
                let len = val.length
                this.checkAll = len === this.excludePayPlatform.length
                this.checkAllFlag = len > 0 && len < this.excludePayPlatform.length
            },
        }
    }
</script>
<style lang="less" scoped>
    .dm-list {
        table {
            // table-layout: fixed;
            word-wrap: break-word;
        }
        .list-label-x {
            float: left;
            width: 150px;
            padding: 0;
            margin: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            font-weight: normal;
        }
        .list-label-y {
            float: left;
            width: 158px;
            padding: 0;
            margin: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            font-weight: normal;
        }
    }
    /* 组别 */
    .group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
    .pay-platform-pop {
        display: none;
        .el-checkbox {
            width: 200px;
            margin: 10px;
        }
    }
</style>